import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {getProductById, editProduct} from "../../../redux/actions/product";
import {Grid,Col} from "react-bootstrap";
import ProfileAnalyseForm from "./ProfileAnalyseForm";

class ProfileAnalyseResult extends Component {

    constructor(props) {
        super(props);
        const id = props.match && props.match.params ? props.match.params.id : null;
        if (id) {
            props.getProductById(id);
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            vProductProfiles: '',
            vProfile: '',
            nomProd: '',
            id: '',
            profi: '',
            result: {
                status:null,
                data:"Après avoir selectionner vos données appuyer sur le button ci-dessous pour lancer l'analyse "
            }
        }
    }

    componentDidUpdate(prevProps) {
        // Quand le produit complet est chargé, mettre à jour les profils contre-indiqués
        if (prevProps.product !== this.props.product && this.props.product && this.props.product.profilesContreIndiquees) {
            this.updateProductProfiles(this.props.product);
        }
    }

    updateProductProfiles = (product) => {
        if (!product.profilesContreIndiquees) {
            this.setState({
                vProductProfiles: [],
                profi: '',
            });
            return;
        }

        if(product.profilesContreIndiquees.includes('$')){
            this.setState({
                vProductProfiles: product.profilesContreIndiquees.split("$"),
                profi: product.profilesContreIndiquees,
            });
        } else {
            // Traitement du format avec parenthèses
            let newProfilesContreIndiquees='';
            let controle=1;

            product.profilesContreIndiquees.split('').forEach(element => {
                if(element=="(") {
                    controle=-1
                }
                else if(element==")") {
                    controle=1
                }

                if(controle==1) {
                    if(element==","){
                        newProfilesContreIndiquees+="$";
                    }
                    else {
                        newProfilesContreIndiquees+=element;
                    }
                }
                else {
                    newProfilesContreIndiquees+=element;
                }
            });
            
            this.setState({
                vProductProfiles: newProfilesContreIndiquees.split('$'),
                profi: newProfilesContreIndiquees,
            });
        }
    }

    onChangeProfile = profiles => {
        this.setState({vProfile: profiles.value});
    }

    onChangeProduct = product => {
        // Mise à jour de l'état avec les données disponibles
        this.setState({
            id: product.value,
            nomProd: product.label,
        });
        
        // Charger le produit complet pour avoir les détails de contre-indications
        this.props.getProductById(product.value);
        
        // Si les données de profils sont déjà disponibles, les traiter immédiatement
        if(product.profilesContreIndiquees && product.profilesContreIndiquees !== '') {
            this.updateProductProfiles({
                profilesContreIndiquees: product.profilesContreIndiquees
            });
        }
    }

    onSubmit(event) {
        event.preventDefault();
        if(this.state.nomProd==''||this.state.vProfile == ''){
            this.setState({result: {status:0, data:"VEUILLEZ SELECTIONNER LES DONNEES A ANALYSER !"}});
            this.props.showNotification("Champ vide !", "danger");
        }
        else if(this.state.vProductProfiles.indexOf(this.state.vProfile.toLowerCase()) != -1){
            this.setState({result: {status:1, data:"< "+this.state.nomProd+" > "+" est contre-indiqué dans le profile "+"< "+this.state.vProfile+" >"}});
            this.props.showNotification("< "+this.state.nomProd+" > "+" est contre-indiqué dans le profile "+"< "+this.state.vProfile+" >", "warning");
        } else{
            this.setState({result: {status:-1, data:"< "+this.state.nomProd+" > "+" n'est pas contre-indiqué dans le profile "+"< "+this.state.vProfile+" >"}});
            this.props.showNotification("< "+this.state.nomProd+" > "+" n'est pas contre-indiqué dans le profile "+"< "+this.state.vProfile+" >", "success");
        }  
        const prof = {
            profilesContreIndiquees: this.state.profi,
            nom: this.state.nomProd,
            _id: this.state.id
            
        }
        /*
        if (!this.props.product.profilesContreIndiquees.includes('$')) {
            this.props.editProduct(Object.assign({}, this.props.product, prof));
        }
        */
    }
     
    render() {
        return (
            <div className="main-content">
                <Grid fluid>
                    <Col sm={12}>
                        <form onSubmit={this.onSubmit}>
                            <ProfileAnalyseForm
                                onChangeProduct = {this.onChangeProduct}
                                onChangeProfile = {this.onChangeProfile}
                                result={this.state.result}
                                showNotification={this.props.showNotification}
                            />
                        </form>
                    </Col>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
        product: state.products.product,        
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getProductById: id => {
            dispatch(getProductById(id));
        },
        editProduct: product => {
            dispatch(editProduct(product));
        },
        showNotification: (message, status) => {
            dispatch({
                type: 'SET_MESSAGE',
                payload: { message, status }
            });
        }
    }
};

ProfileAnalyseResult.propTypes = {
    match: PropTypes.object,
    message: PropTypes.object,
    loading: PropTypes.bool,
    showNotification: PropTypes.func,
    getProductById: PropTypes.func,
    editProduct: PropTypes.func,
    product: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAnalyseResult);